import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { distinctUntilChanged, filter, switchMap } from 'rxjs'

import { OnboardPersistState, persistence, persistStateFactory } from '../state/persistence'

const persistStudentState$ = persistStateFactory(persistence.studentApiUrl)

const [studentPersistedStateChange$, setStudentPersistedState] = createSignal<OnboardPersistState>()

export { setStudentPersistedState }

export const [useOnboardStudentPersist, persistedStudentState$] = bind(
  studentPersistedStateChange$.pipe(
    filter(({ state }) => !state.endsWith('Persist')),
    distinctUntilChanged((prev, next) => prev.state === next.state),
    switchMap(persistStudentState$),
  ),
  {
    loading: false,
    result: null,
    called: false,
  },
)
